import * as React from "react";
import { useRive, Layout, Fit, Alignment } from "@rive-app/react-canvas";

interface HeroRiveProps {
  className?: string;
  stateMachine?: string;
  artboard?: string;
  offsetX?: number;
  offsetY?: number;
  scale?: number;
}

export function HeroRive({
  className,
  stateMachine = "State Machine 1",
  artboard,
  offsetX = 0,
  offsetY = 0,
  scale = 1,
}: HeroRiveProps) {
  const { RiveComponent } = useRive({
    src: "/rive/brev-hero-empty-text.riv",
    stateMachines: stateMachine,
    artboard,
    autoplay: true,
    layout: new Layout({
      fit: Fit.Contain,
      alignment: Alignment.Center,
    }),
  });

  return (
    <div
      className={className}
      style={{
        transform: `translate(${offsetX}px, ${offsetY}px) scale(${scale})`,
      }}
    >
      <RiveComponent />
    </div>
  );
}
